<template>
  <el-dialog class='userMsgbox' title="编辑个人资料" :before-close="handleClose" :close-on-click-modal="false" top='50px'
    width="776px" :visible.sync="showUserinfo" :modal-append-to-body='false' :append-to-body="true">
    <div>
      <el-form class='SDAU_form' ref="form" :model="formData" :rules='rules'>
        <el-row>
          <el-col style='margin-bottom:40px' :span="24">
            <el-form-item label="个人头像">
              <!-- <img style="width: 30px; height: 30px;" src="../../../assets/logo.png" class="user-avatar"> -->
              <el-upload class="avatar-uploader" :action='action' :show-file-list="false" :headers="uploadData"
                :on-success='handleAvatarSuccess' name='avatarfile' :before-upload="beforeAvatarUpload">
                <img style='width: 80px;height:80px' v-if="avatar" :src="avatar" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="10" style='padding-right:30px'>
            <el-form-item label="姓名" prop='nickName'>
              <el-input v-model="formData.nickName" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item label="性别" prop='sex'>
              <el-select v-model="formData.sex" placeholder="请选择性别">
                <el-option label="男" value="0"></el-option>
                <el-option label="女" value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="email" prop="email">
              <el-input v-model="formData.email" placeholder="请输入邮箱"></el-input>
            </el-form-item>
            <el-form-item label="通讯地址" prop="address">
              <el-input v-model="formData.address" placeholder="请输入通讯地址"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span='14'>
            <el-form-item label="联系电话" prop="phonenumber">
              <el-input v-model="formData.phonenumber" placeholder="请输入联系电话"></el-input>
            </el-form-item>
            <el-form-item label="身份证号" prop="idCard">
              <el-input v-model="formData.idCard" placeholder="请输入身份证号"></el-input>
            </el-form-item>
            <el-form-item label="课题组" prop='projectTeamGroupNames'>
              <el-input disabled v-model="formData.projectTeamGroupNames" placeholder="课题组"></el-input>
            </el-form-item>

          </el-col>
        </el-row>
      </el-form>
    </div>
    <span slot="footer">
      <el-button style="margin:0 24px 0 530px;" type="primary" @click="detail_save">保存</el-button>
      <el-button t @click="$emit('cancel')">返回</el-button>
    </span>
  </el-dialog>
</template>
<script>
const { APIURl } = require('@/utils/apiUrl')
export default {
  props: {
    showUserinfo: {
      default: false
    },
    thisToken: {
      default: false
    }

  },
  data() {
    return {
      formData: {},
      rules: {
        nickname: [
          { required: true, message: '请输入昵称', trigger: ["blur", 'change'] },
        ],
        address: [
          { required: false, message: '校外用户需输入通讯地址', trigger: ["blur", 'change'] },
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: ["blur", 'change'] },
          {
            pattern: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/,    //正则校验不用字符串
            message: "请填写正确的邮箱", trigger: "blur"
          }
        ],
        phonenumber: [
          { required: true, message: '请输入手机号', trigger: ["blur", 'change'] },
          {
            pattern: /^.{11}$/,    //正则校验不用字符串
            message: "手机号码格式有误", trigger: "blur"
          }
        ],
        idCard: [
          {
            pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,    //正则校验不用字符串
            message: "请填写正确的身份证号", trigger: "blur"
          }
        ]
      },
      action: APIURl + '/system/user/profile/avatar',
      uploadData: {},
      avatar: ''
    }
  },
  methods: {
    handleClose() {
      this.$emit('cancel')
    },
    beforeAvatarUpload() {

    },
    detail_save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$net('/sdau/usermanage/updateStudentUserInfo', 'put', this.formData).then(res => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: "修改成功"
              })
              this.handleClose()
              // setTimeout(() => {
              //   location.reload();
              // }, 1000)
            }
          })
        }
      })
    },
    init() {
      this.formData = JSON.parse(JSON.stringify(this.$store.getters.userInfo))
      this.uploadData.Authorization = this.thisToken
      this.avatar = APIURl + '/' + this.formData.avatar
      this.rules.address[0].required = this.formData.deptId == 151 ? true : false
    },
    handleAvatarSuccess(res) {
      this.avatar = APIURl + '/' + res.imgUrl
      this.formData.avatar = res.imgUrl
    },
  },
  created() {
    this.init()
  },
}
</script>
<style lang="scss" scoped>
::v-deep.SDAU_form {
  .el-form-item__label {
    height: 32px;
    font-size: 16px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    line-height: 32px;
    color: #333333;
    padding-bottom: 8px;
  }

  .el-form-item__content {
    width: 100%;
    height: 72px;

    .el-select {
      width: 100%;
    }
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    margin: 36px 0 0 -76px;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
}

.el-select-dropdown__item {
  width: 100%;
}
</style>